import { ApiError } from "../../services/restApiService";

/** Definite access/publication refusals invalidate every containing aggregate view. */
export function isOverviewAccessRefusal(error: unknown): error is ApiError {
  return error instanceof ApiError && [401, 403, 404, 409, 503].includes(error.status);
}
